import { render, staticRenderFns } from "./DiscussionForumCard.vue?vue&type=template&id=9fa03348&scoped=true&"
import script from "./DiscussionForumCard.vue?vue&type=script&lang=js&"
export * from "./DiscussionForumCard.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionForumCard.vue?vue&type=style&index=0&id=9fa03348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa03348",
  null
  
)

export default component.exports